<template>
  <div
    class="jornada"
    v-if="agendamentosDeHoje !== null && agendamentosDeHoje.length > 0"
    @click="exibirTimeline = !exibirTimeline"
  >
    <simple-card>
      <div slot="title">
        <template v-if="proximoAgendamentoHoje">
          Seu próximo atendimento hoje:
        </template>
        <template v-else> Não há mais atendimentos para hoje! </template>
      </div>
      <div
        slot="content"
        class="proximoatendimento-container"
        v-if="proximoAgendamentoHoje"
      >
        <h1 class="proximoatendimento-hora">
          {{ proximoAgendamentoHoje.Hora }}
        </h1>
        <h2 class="proximoatendimento-descricao">
          {{ proximoAgendamentoHoje.Descricao }} -
          {{ textoObservacao(proximoAgendamentoHoje.FormaAtendimento) }}
        </h2>
      </div>
      <div slot="footer">
        <div v-if="exibirTimeline" class="timeline-container">
          <form-timeline
            :steps="steps"
            :current-step="currentStep"
            :vertical="true"
          />
        </div>
        <div class="expandir-timeline">
          <div class="expandir-timeline__label">
            VER {{ exibirTimeline ? 'MENOS' : 'MAIS' }}
          </div>
          <i
            :class="
              exibirTimeline
                ? 'icon-ic_chevron_up_gray'
                : 'icon-ic_chevron_down_gray'
            "
          />
        </div>
      </div>
    </simple-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormTimeline from '@/components/shared/forms/FormTimeline'
import SimpleCard from '../shared/cards/SimpleCard.vue'
import { FormaAtendimento } from '@/mixins/forma-atendimento'

export default {
  name: 'JornadaPaciente',
  props: {
    profile: {
      type: String,
      default: () => ''
    }
  },
  components: {
    FormTimeline,
    SimpleCard
  },
  computed: {
    ...mapGetters({
      agendamentosDeHoje: 'agendamentosDeHoje',
      proximoAgendamentoHoje: 'proximoAgendamentoHoje'
    }),
    releaseSolicitacao() {
      return process.env.VUE_APP_SOLICITACAO_RELEASE !== 'false'
    },
    steps() {
      return this.agendamentosDeHoje.map((m) => ({
        name: `${m.Hora} - ${m.Descricao} - ${this.textoObservacao(
          m.FormaAtendimento
        )}`
      }))
    },
    currentStep() {
      let idx = this.agendamentosDeHoje.findIndex(
        (m) =>
          this.proximoAgendamentoHoje != null &&
          m.CodigoAtendimento === this.proximoAgendamentoHoje.CodigoAtendimento
      )
      return idx < 0 ? this.agendamentosDeHoje.length : idx
    }
  },
  data() {
    return {
      exibirTimeline: false
    }
  },
  methods: {
    textoObservacao(formaAtendimento) {
      switch (formaAtendimento) {
        case FormaAtendimento.Videoconferencia:
          return this.$t('agenda.video')
        case FormaAtendimento.Telefone:
          return this.$t('agenda.telefone')
        default:
          return this.$t('agenda.presencial')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.jornada {
  margin-bottom: 3.75rem;
}
.steps {
  ul {
    li {
      background-color: none;
    }
  }
}
.expandir-timeline {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 0.7rem;

  color: var(--gray-500);
  border-top: 1px solid #dbdbdb;
  padding: 7px;
  i {
    padding-bottom: 0;
  }
}
.timeline-container {
  border-top: 1px solid #dbdbdb;
}
.proximoatendimento-container {
  margin-top: 7px;
  padding: 3px;
}
.proximoatendimento-hora {
  font-size: 20px;
  font-weight: 600;
}
.proximoatendimento-descricao {
  margin-top: 3px;
  font-size: 18px;
  font-weight: 600;
}
</style>
